import { render, staticRenderFns } from "./EntitySettingsTabLinks.vue?vue&type=template&id=6314b21e"
import script from "./EntitySettingsTabLinks.vue?vue&type=script&lang=js"
export * from "./EntitySettingsTabLinks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports